import React from 'react';
import { Flame, Sparkles } from 'lucide-react';

/**
 * ForgeEntrance - The starting point flame at the bottom of the path
 */
export default function ForgeEntrance({ 
  onClick,
  isActive = true 
}) {
  return (
    <div className="relative flex flex-col items-center pt-8 pb-12">
      {/* Background glow */}
      <div 
        className="absolute top-0 left-1/2 -translate-x-1/2 w-40 h-40 rounded-full blur-3xl -z-10"
        style={{
          background: 'radial-gradient(circle, rgba(249, 115, 22, 0.3) 0%, rgba(220, 38, 38, 0.1) 50%, transparent 70%)'
        }}
      />
      
      {/* Forge platform */}
      <div className="relative">
        {/* Platform base */}
        <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-28 h-4 bg-gradient-to-b from-slate-600 to-slate-700 rounded-b-lg" />
        <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-24 h-2 bg-gradient-to-b from-slate-500 to-slate-600 rounded-b-sm" />
        
        {/* Main flame button */}
        <button
          onClick={onClick}
          className={`
            relative w-20 h-20 rounded-full 
            bg-gradient-to-br from-orange-500 via-orange-600 to-red-600 
            flex items-center justify-center 
            border-4 border-orange-400 
            shadow-2xl shadow-orange-500/50
            transition-all duration-300
            ${isActive ? 'hover:scale-110 active:scale-95 cursor-pointer' : 'opacity-50 cursor-not-allowed'}
          `}
        >
          {/* Inner glow */}
          <div className="absolute inset-2 rounded-full bg-gradient-to-t from-transparent via-orange-400/30 to-yellow-400/40" />
          
          {/* Flame icon */}
          <Flame className="h-10 w-10 text-white relative z-10 drop-shadow-lg" />
          
          {/* Pulse ring */}
          <div className="absolute inset-0 rounded-full bg-orange-500/40 animate-ping" />
          
          {/* Outer glow ring */}
          <div 
            className="absolute -inset-2 rounded-full animate-pulse"
            style={{
              background: 'radial-gradient(circle, rgba(249, 115, 22, 0.4) 0%, transparent 70%)'
            }}
          />
        </button>
        
        {/* Sparkle decorations */}
        <Sparkles 
          className="absolute -top-2 -left-4 h-5 w-5 text-yellow-400 animate-pulse" 
          style={{ animationDelay: '0.3s' }}
        />
        <Sparkles 
          className="absolute top-4 -right-6 h-4 w-4 text-orange-400 animate-pulse" 
          style={{ animationDelay: '0.7s' }}
        />
        <Sparkles 
          className="absolute -bottom-6 left-2 h-3 w-3 text-amber-400 animate-pulse" 
          style={{ animationDelay: '1s' }}
        />
      </div>
      
      {/* Label */}
      <div className="mt-6 text-center">
        <p className="text-orange-400 font-bold text-lg tracking-wide drop-shadow-lg">
          Begin Your Journey
        </p>
        <p className="text-slate-500 text-sm mt-1">
          Lesson 1
        </p>
      </div>
      
      {/* Decorative line */}
      <div className="mt-4 w-32 h-px bg-gradient-to-r from-transparent via-orange-500/50 to-transparent" />
    </div>
  );
}
